import { render, staticRenderFns } from "./tabsBody.vue?vue&type=template&id=09b330ca&scoped=true&"
import script from "./tabsBody.vue?vue&type=script&lang=js&"
export * from "./tabsBody.vue?vue&type=script&lang=js&"
import style0 from "./tabsBody.vue?vue&type=style&index=0&id=09b330ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b330ca",
  null
  
)

component.options.__file = "tabsBody.vue"
export default component.exports